// services/providerService.js

import { registerPatient } from "../slices/patientSlice";

/**
 * Fetches a provider by ID:
 * - Checks the Redux store first
 * - If not present, fetches from FHIR server and registers it
 */
export const fetchPatient = async (patientId, fhirClient, getState, dispatch) => {
    if (!patientId || !fhirClient) return null;

    // Check Redux store
    const cached = getState().patients?.[patientId];
    if (cached) return cached;

    try {
        const fetched = await fhirClient.request(`Patient/${patientId}`);
        dispatch(registerPatient(fetched));
        return fetched;
    } catch (err) {
        console.error("? Failed to fetch patient:", err);
        return null;
    }
};

export const fetchPatientByReference = async (ref, fhirClient, getState, dispatch) => {
    if (!ref || !ref.startsWith("Patient/") || ref == "Patient/undefined") {
        console.warn("⚠️ Invalid patient reference:", ref);
        return null;
    }

    const patientId = ref.split("/")[1];
    if (!patientId) {
        console.warn("⚠️ Could not extract patient ID from reference:", ref);
        return null;
    }

    return fetchPatient(patientId, fhirClient, getState, dispatch);
};